export const flickrConfig = {
  api: 'https://www.flickr.com/services/rest/',
  apiKey: '502e4a91e4940cffa841abeeab473e6b',
};
